<template>
  <section class="pt-container">
    <div class="pt-header">
      <div class="pt-title">
        Saída de produtos
        <span id="help-icon" class="icon-box"><v-help-circle class="icon stroke" /></span>
        <b-tooltip target="help-icon" placement="bottom">
          Efetue a saída de produtos no seu estoque, tenha controle de todos os detalhes, lotes, profissionais, pacientes e valores de todas as saídas.
        </b-tooltip>
      </div>

      <div>
        <b-button class="wh-button no-print" variant="outline-primary" outline @click="getOutputsXlsx">
          Download xlsx
        </b-button>
      </div>
    </div>

    <div class="row">
      <b-col cols="5">
        <b-form-group>
          <div class="search-container">
            <Search class="icon" />
            <b-form-input
              class="placeholder-color"
              id="search"
              debounce="500"
              autocomplete="off"
              placeholder="Buscar por nome do produto, código de barras ou código interno"
              v-model="query"
            />
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-button variant="primary" class="mr-2" @click="searchOutputs">Aplicar</b-button>
        <b-button variant="outline-primary" @click="openInfoSidebar()" class="button-wrapper">
          <FilterBar /> Filtros
          <div v-if="filterApplied" class="pulsating-circle"></div>
        </b-button>
      </b-col>
    </div>

    <v-warehouse-outputs-table
      :entries="entries"
      :onEdit="onEditClick"
      :onDelete="deleteWarehouseOutput"
      :loading="loading"
      :hasFilter="hasFilter"
    />

    <div id="resume" class="row justify-content-end">
      <div class="info-box">
        <div class="">
          <span class="d-block text-muted info-box-text">Valor total de produtos</span>
          <span class="fs-4 info-box-value">{{ parseNumberToMoney(resume.total_value_products) }}</span>
        </div>
      </div>
      <div class="info-box">
        <div class="">
          <span class="d-block text-muted info-box-text">Imposto estimado</span>
          <span class="fs-4 info-box-value">{{ parseNumberToMoney(resume.estimated_tax) }}</span>
        </div>
      </div>
      <div class="info-box">
        <div class="">
          <span class="d-block text-muted info-box-text">Total de despesas</span>
          <span class="fs-4 info-box-value">{{ parseNumberToMoney(resume.total_expenses) }}</span>
        </div>
      </div>
      <div class="info-box">
        <div class="">
          <span class="d-block text-muted info-box-text">Valor total</span>
          <span class="fs-4 info-box-value text-blue">{{ parseNumberToMoney(resume.total_amount) }}</span>
        </div>
      </div>
    </div>

    <div class="pagination-position">
      <b-pagination
        size="sm"
        v-model="page"
        :total-rows="count"
        :per-page="limit"
        first-number
        last-number
      />
    </div>

    <StockOutFilterSidebar
      @change="updateFilter"
      @updateFilterApplied="updateFilterApplied"
      :query="query"
    />

  </section>
</template>
<script>
import { saveAs } from 'file-saver';
import { EventBus } from '@/utils/eventBus';
import HelpCircle from '@/assets/icons/help-circle.svg'
import WarehouseOutputsTable from '@/components/Warehouse/WarehouseOutputsTable'
import { parseNumberToMoney } from '@/utils/moneyHelper'

export default {
  name: 'warehouse-output-tab',
  components: {
    'v-help-circle': HelpCircle,
    'v-warehouse-outputs-table': WarehouseOutputsTable,
    Search: () => import('@/assets/icons/search.svg'),
    FilterBar: () => import('@/assets/icons/filter-bar.svg'),
    StockOutFilterSidebar: () => import('./StockOutFilterSidebar.vue'),
  },
  props: {
    onEditOutputClick: Function,
  },
  created () {
    // 
  },
  mounted () {
    this.getWarehouseOutputs();
    this.getProfessionals();
    EventBus.$on('reloadProductOutputs', () => this.getWarehouseOutputs(true));
  },
  data() {
    return {
      clinic: JSON.parse(localStorage.getItem('clinic')),
      page: 1,
      limit: 0,
      count: 0,
      query: '',
      type: null,
      start: null,
      end: null,
      batch: null,
      batchQuery: null,
      professional_id: null,
      professionalQuery: null,
      patient: null,
      patientQuery: null,
      procedure_id: null,
      procedureQuery: null,
      health_plan_id: null,
      healthPlanQuery: null,
      transactions: [],
      loading: false,
      hasFilter: false,
      filters: {},
      filterApplied: false,
      resume: {},
      entries: []
    }
  },
  methods: {
    parseNumberToMoney,
    handlePeriod(value) {
      this.start = value.start;
      this.end = value.end;
    },
    getWarehouseTransactions(hideLoading) {
      this.loading = true;

      // const patientId = this.patient ? this.patient.id : null;

      this.hasFilter = (this.query || Object.values(this.filters).length > 0);

      let isLoading = null;
      if (!hideLoading) {
        isLoading = this.$loading.show();
      }

      const filters = this.filters;
      filters.page = this.page;

      if(this.query) 
        filters.query = this.query;

      this.api.getWarehouseOutputTransactions(this.clinic.id, filters)
      .then(res => {
        this.transactions = res.data.data;
        this.count = res.data.total;
        this.limit = res.data.per_page;
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => {
        this.loading = false;
        isLoading && isLoading.hide();
      });
    },
    async getWarehouseOutputs(hideLoading) {
      const queryString = window.location.search;      
      const params = new URLSearchParams(queryString);

      this.loading = true;
      this.hasFilter = (this.query || Object.values(this.filters).length > 0);
      const isLoading = !hideLoading && this.$loading.show();
      const filters = this.filters;

      filters.query = this.query ? this.query : '';
      filters.page = this.page;

      if(params.get("status")){
        filters.status = params.get("status");

        params.delete("status");

        // const newUrl = `${window.location.pathname}?${params.toString()}`;
        // window.history.replaceState({}, '', newUrl);
      }

      await this.api.getWarehouseOutputs(this.clinic.id, filters)
      .then(res => {
        this.entries = res.data.data;
        this.count = res.data.total;
        this.limit = res.data.per_page;
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => {
        this.loading = false;
        !hideLoading && isLoading.hide();
        this.getWarehouseSummaryOutputs(hideLoading, filters);
      });
    },
    getWarehouseSummaryOutputs(hideLoading, filters) {
      this.loading = true;
      const isLoading = !hideLoading && this.$loading.show();
      filters.page = this.page;
      this.api.getWarehouseSummaryOutputs(this.clinic.id, filters)
      .then(res => {
        const { total_value_products, estimated_tax, total_expenses, total_amount } = res.data;
        
        this.resume = {
          total_value_products,
          estimated_tax,
          total_expenses,
          total_amount
        };
        
      })
      .catch(err => {
        this.resume = {
          total_value_products: 0,
          estimated_tax: 0,
          total_expenses: 0,
          total_amount: 0,
        };
        
        this.$toast.error(err.message)
      })
      .finally(() => {
        this.loading = false;
        !hideLoading && isLoading.hide();
      });
    },
    deleteWarehouseOutput(transaction) {
      const isLoading = this.$loading.show();
      this.api.deleteWarehouseOutput(transaction.id)
      .then(() => {
        this.$toast.success('Saída excluida com sucesso');
        this.getWarehouseOutputs();
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => isLoading.hide());
    },
    deleteWarehouseTransaction(entry) {
      const isLoading = this.$loading.show();
      this.api.deleteWarehouseOutput(entry.id)
      .then(() => {
        this.$toast.success('Saída excluida com sucesso');
        this.getWarehouseTransactions();
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => isLoading.hide());
    },
    onEditClick(entry) {
      const output = {
        ...entry,
        transactions: entry.warehouse_product_transactions
      };
      this.onEditOutputClick(output);
    },
    getProfessionals() {
      this.api.showClinicProfessionals(this.clinic.id)
      .then(res => {
        this.professionals = res.data;
      })
      .catch(err => this.$toast.error(err.message));
    },
    getOutputsXlsx() { // mudar aqui
      const isLoading = this.$loading.show();
      const filters = {
        query: this.query,
        type: this.type, 
        start: this.start,
        end: this.end,
        batch: this.batch, 
        professional_id: this.professional_id,
        patient_id: this.patient ? this.patient.id : null,
        procedure_id: this.procedure_id,
        health_plan_id: this.health_plan_id
      }
      this.api.getWarehouseOutputsExport(this.clinic.id, filters)
      .then(res => {
        saveAs(
          new Blob([res.data], {
            type: 'application/vnd.ms-excel',
          }),
          'saidas.xlsx'
        );
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => isLoading.hide());
    },
    openInfoSidebar() {
      this.$root.$emit('bv::toggle::collapse', 'filter-product-sidebar')
    },
    async searchOutputs() {
      this.currentPage = 1
      this.rows = [];
      this.getWarehouseOutputs();
    },
    async updateFilter(newFilter) {
      this.filters = newFilter
      this.currentPage = 1
      this.rows = [];
      this.getWarehouseOutputs();
    },
    async updateFilterApplied(){
      const filters = this.filters;
      
      for (var propName in filters) {
        if (filters[propName] === null || filters[propName] === undefined || filters[propName] === '') {
          delete filters[propName];
        }
      }

      delete filters.page;
      delete filters.type;

      this.filterApplied = Object.values(filters).length > 0;
    },
  },
  watch: {
    query: function() { this.getWarehouseOutputs(); },
    page: function() { this.getWarehouseOutputs(); },
  }
}
</script>
<style scoped lang="scss">
  .pt-container {
    padding: 30px 10px;
    .pt-header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0 30px 0;
    }
    .pt-title {
      display: inline-flex;
      align-items: center;
      font-family: 'Red Hat Display';
      font-weight: 500;
      font-size: 18px;
    }

    .placeholder-color::placeholder {
      color: var(--type-placeholder);
    }

    .icon {
      height: 24px;
      width: 24px;
      margin-left: 5px;
      stroke: var(--neutral-500);
    }
    .pagination-position {
      width: 100%;
      display: inline-flex;
      justify-content: flex-end;
    }
    label {
      width: 100%;
      font-family: 'Nunito Sans';
      font-weight: 700;
      font-size: 16px;
      color: #525C7A;
      text-align: left !important;
      color: var(--dark-blue);
      margin-bottom: 4px;
    }
    .wh-button {
      margin: 0 0 0 10px;
      border-color: var(--blue-500);
      color: var(--blue-500);
    }

    #resume {
      .info-box {
        width: 152px;
        padding: 4px 12px 4px 12px;
        gap: 0px;
        border-radius: 8px;
        opacity: 0px;
        background: var(--blue-grey-neutral-eyecare-100, #F4F5FB);
        margin: 0px 5px;
        padding: 12px;

        .info-box-text {
          font-size: 12px;
        }

        .info-box-value {
          color: var(--Brand-blue-900, #142666);
          font-size: 16px;
          font-weight: 700;
          line-height: 21px;
          text-align: right;

          &.text-blue {
            color: #305BF2;
          }

        }

      }
    }

    .pulsating-circle {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
      background-color: var(--orange);
      border-radius: 50%;
      width: 10px;
      height: 10px;
    }

    .search-container {
      display: flex;
      flex-direction: row;
      position: relative;
      .icon {
        position: absolute;
        width: 24px;
        height: 24px;
        stroke: var(--neutral-500);
        height: 100%;
        margin-left: 10px;
      }

      input {
        padding-left: 40px !important;
      }
    }
  }
</style>

